
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.25 4H6.75A1.752 1.752 0 0 0 5 5.75v2.5A1.752 1.752 0 0 0 6.75 10h.75v16.25A1.752 1.752 0 0 0 9.25 28h13.5a1.752 1.752 0 0 0 1.75-1.75V10h.75A1.752 1.752 0 0 0 27 8.25v-2.5A1.752 1.752 0 0 0 25.25 4ZM9 10h4v3H9v-3Zm0 4.5h8.5v3H9v-3ZM9 19h4v3H9v-3Zm8.5 7.5H9.25a.25.25 0 0 1-.25-.25V23.5h8.5v3Zm5.5-.25a.25.25 0 0 1-.25.25H19v-3h4v2.75ZM23 22h-8.5v-3H23v3Zm0-4.5h-4v-3h4v3Zm0-4.5h-8.5v-3H23v3Zm2.5-4.75a.25.25 0 0 1-.25.25H6.75a.25.25 0 0 1-.25-.25v-2.5a.25.25 0 0 1 .25-.25h18.5a.25.25 0 0 1 .25.25v2.5Z"}})])
          )
        }
      }
    